// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.challenge-overview-container {
  background: #ffffff;
  padding: 24px;
  min-height: 100vh;
  font-family: 'roboto', sans-serif;
}

.challenge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.challenge-header h2 {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}
.challenge-options {
  display: flex;
  align-items: center;
  gap: 15px;
}
.challenge-options .mwl-datepicker-button.MuiButton-root {
  padding: 7px !important;
}
.challenge-options .Wlb-AutoComplete {
  gap: 0px !important;
}
.challenge-options select {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  background: #fff;
  font-size: 15px;
}

.challenge-top-row {
  display: flex;
  gap: 18px;
  margin-bottom: 18px;
}

.challenge-validation-card,
.challenge-ocr-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  padding: 18px 22px;
  flex: 2;
  display: flex;
  flex-direction: column;
  min-width: 0;
  border: 1px solid #e0e0e0;
}

.challenge-ocr-card {
  flex: 1.2;
  align-items: flex-start;
  justify-content: flex-start;
}

.challenge-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  font-weight: 400;
}

.challenge-card-header a {
  font-size: 13px;
  color: #4a90e2;
  text-decoration: none;
  font-weight: 500;
}

.challenge-bar-legend {
  display: flex;
  gap: 18px;
  font-size: 12px;
  font-weight: 400;
  justify-content: center;
}

.challenge-ocr-main {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 10px;
  margin-bottom: 12px;
}

/* Add divider line below OCR main result */
.challenge-ocr-divider {
  width: 100%;
  height: 1px;
  background: #e0e0e0;
  margin: 6px 0 12px 0;
}

/* Increase gap between divider and bars */
.challenge-ocr-bars {
  width: 100%;
  margin-top: 0;
}

.challenge-ocr-percent {
  font-size: 32px;
  font-weight: 700;
  color: #222;
}

.challenge-ocr-change {
  font-size: 16px;
  color: #43a047;
  font-weight: 600;
  border-radius: 16px;
  padding: 2px 8px;
  border: 1px solid #43a047;
}

.challenge-ocr-bars {
  width: 100%;
}

.challenge-ocr-bar-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 15px;
  gap: 0;
  width: 100%;
}

.challenge-ocr-bar-label {
  flex: 0 0 120px;
  color: #757575;
  font-size: 15px;
  min-width: 80px;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.challenge-ocr-bar-track {
  flex: 1;
  background: #e9ecef;
  height: 6px;
  margin: 0 18px 0 0;
  position: relative;
  display: flex;
  align-items: center;
}

.challenge-ocr-bar-fill {
  background: #3276cf;
  height: 100%;
  transition: width 0.3s;
}

.challenge-ocr-bar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 70px;
}

.challenge-ocr-bar-value {
  font-size: 16px;
  font-weight: 400;
  color: #222;
  margin-left: 0;
}

.challenge-ocr-bar-change {
  font-size: 14px;
  color: #43a047;
  margin-left: 0;
  font-weight: 400;
  background: none;
  padding: 0;
}

.challenge-bottom-row {
  display: flex;
  gap: 18px;
}

.challenge-summary-card,
.challenge-agents-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  padding: 18px 22px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  border: 1px solid #e0e0e0;
}

.challenge-summary-controls {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 10px;
}

.challenge-agents-tabs {
  display: flex;
  gap: 12px;
  margin-top: 12px;
  margin-bottom: 6px;
}

.challenge-agents-tabs button {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 4px 18px;
  font-size: 13px;
  font-weight: 400;
  color: #222;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border 0.2s;
}

.challenge-agents-tabs button.active {
  background: #3276cf;
  color: #fff;
  border: 1px solid #3276cf;
}

.challenge-agents-chart-row {
  display: flex;
  align-items: center;
  gap: 40px;
  margin-top: 10px;
}

.challenge-agents-legend {
  display: flex;
  flex-direction: column;
  gap: 18px;
  font-size: 14px;
  font-weight: 400;
  color: #555;
}

.challenge-agents-legend-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 220px;
  flex-wrap: nowrap; /* prevent wrapping of count */
}

.challenge-agents-legend-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 10px;
  vertical-align: middle;
}

.challenge-agents-legend-label {
  flex: 1;
  min-width: 0;
  white-space: normal; /* allow label to wrap if needed */
  overflow: hidden;
  text-overflow: ellipsis;
}

.challenge-agents-legend-count {
  font-weight: 500;
  color: #212121;
  margin-left: 16px;
  letter-spacing: 1px;
  min-width: 32px;
  text-align: right;
  white-space: nowrap; /* prevent count from wrapping */
  flex-shrink: 0; /* always keep count on same line */
}

.agents-interventions-panel {
  padding: 0px 13px;
  padding-top: 10px;
  height: 92vh;
  overflow: auto;
}

.apexcharts-legend {
  font-size: 13px !important;
}

@media (max-width: 900px) {
  .challenge-top-row,
  .challenge-bottom-row {
    flex-direction: column;
  }
}

@media (min-width: 901px) and (max-width: 1024px) {
  .challenge-ocr-bar-label {
    flex: 0 0 250px;
    max-width: 130px;
  }

  .challenge-agents-chart-row {
    gap: 10px !important;
  }
}

@media (min-width: 1025px) and (max-width: 1440px) {
  .challenge-ocr-bar-label {
    flex: 0 0 250px;
    max-width: 160px;
  }
}

@media (min-width: 1441px) {
  .challenge-ocr-bar-label {
    flex: 0 0 250px;
    max-width: 250px;
  }
}

.challenge-card-header .buttonContainer .MuiButton-text.MuiButton-textSuccess {
  color: #3276cf;
}
.challenge-options .date-picker-container .colWiseControl {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.challenge-options .date-picker-container .controlLabel {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/custom/challengeoverview/ChallengeOverview.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB,EAAE,8BAA8B;AACnD;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB,EAAE,kCAAkC;EACvD,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB,EAAE,gCAAgC;EACrD,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".challenge-overview-container {\n  background: #ffffff;\n  padding: 24px;\n  min-height: 100vh;\n  font-family: 'roboto', sans-serif;\n}\n\n.challenge-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.challenge-header h2 {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n}\n.challenge-options {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n.challenge-options .mwl-datepicker-button.MuiButton-root {\n  padding: 7px !important;\n}\n.challenge-options .Wlb-AutoComplete {\n  gap: 0px !important;\n}\n.challenge-options select {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n  background: #fff;\n  font-size: 15px;\n}\n\n.challenge-top-row {\n  display: flex;\n  gap: 18px;\n  margin-bottom: 18px;\n}\n\n.challenge-validation-card,\n.challenge-ocr-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n  padding: 18px 22px;\n  flex: 2;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  border: 1px solid #e0e0e0;\n}\n\n.challenge-ocr-card {\n  flex: 1.2;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.challenge-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 20px;\n  font-weight: 400;\n}\n\n.challenge-card-header a {\n  font-size: 13px;\n  color: #4a90e2;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.challenge-bar-legend {\n  display: flex;\n  gap: 18px;\n  font-size: 12px;\n  font-weight: 400;\n  justify-content: center;\n}\n\n.challenge-ocr-main {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-top: 10px;\n  margin-bottom: 12px;\n}\n\n/* Add divider line below OCR main result */\n.challenge-ocr-divider {\n  width: 100%;\n  height: 1px;\n  background: #e0e0e0;\n  margin: 6px 0 12px 0;\n}\n\n/* Increase gap between divider and bars */\n.challenge-ocr-bars {\n  width: 100%;\n  margin-top: 0;\n}\n\n.challenge-ocr-percent {\n  font-size: 32px;\n  font-weight: 700;\n  color: #222;\n}\n\n.challenge-ocr-change {\n  font-size: 16px;\n  color: #43a047;\n  font-weight: 600;\n  border-radius: 16px;\n  padding: 2px 8px;\n  border: 1px solid #43a047;\n}\n\n.challenge-ocr-bars {\n  width: 100%;\n}\n\n.challenge-ocr-bar-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n  font-size: 15px;\n  gap: 0;\n  width: 100%;\n}\n\n.challenge-ocr-bar-label {\n  flex: 0 0 120px;\n  color: #757575;\n  font-size: 15px;\n  min-width: 80px;\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.challenge-ocr-bar-track {\n  flex: 1;\n  background: #e9ecef;\n  height: 6px;\n  margin: 0 18px 0 0;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.challenge-ocr-bar-fill {\n  background: #3276cf;\n  height: 100%;\n  transition: width 0.3s;\n}\n\n.challenge-ocr-bar-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 70px;\n}\n\n.challenge-ocr-bar-value {\n  font-size: 16px;\n  font-weight: 400;\n  color: #222;\n  margin-left: 0;\n}\n\n.challenge-ocr-bar-change {\n  font-size: 14px;\n  color: #43a047;\n  margin-left: 0;\n  font-weight: 400;\n  background: none;\n  padding: 0;\n}\n\n.challenge-bottom-row {\n  display: flex;\n  gap: 18px;\n}\n\n.challenge-summary-card,\n.challenge-agents-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n  padding: 18px 22px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  border: 1px solid #e0e0e0;\n}\n\n.challenge-summary-controls {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n  gap: 10px;\n}\n\n.challenge-agents-tabs {\n  display: flex;\n  gap: 12px;\n  margin-top: 12px;\n  margin-bottom: 6px;\n}\n\n.challenge-agents-tabs button {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 20px;\n  padding: 4px 18px;\n  font-size: 13px;\n  font-weight: 400;\n  color: #222;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s, border 0.2s;\n}\n\n.challenge-agents-tabs button.active {\n  background: #3276cf;\n  color: #fff;\n  border: 1px solid #3276cf;\n}\n\n.challenge-agents-chart-row {\n  display: flex;\n  align-items: center;\n  gap: 40px;\n  margin-top: 10px;\n}\n\n.challenge-agents-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #555;\n}\n\n.challenge-agents-legend-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-width: 220px;\n  flex-wrap: nowrap; /* prevent wrapping of count */\n}\n\n.challenge-agents-legend-dot {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-right: 10px;\n  vertical-align: middle;\n}\n\n.challenge-agents-legend-label {\n  flex: 1;\n  min-width: 0;\n  white-space: normal; /* allow label to wrap if needed */\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.challenge-agents-legend-count {\n  font-weight: 500;\n  color: #212121;\n  margin-left: 16px;\n  letter-spacing: 1px;\n  min-width: 32px;\n  text-align: right;\n  white-space: nowrap; /* prevent count from wrapping */\n  flex-shrink: 0; /* always keep count on same line */\n}\n\n.agents-interventions-panel {\n  padding: 0px 13px;\n  padding-top: 10px;\n  height: 92vh;\n  overflow: auto;\n}\n\n.apexcharts-legend {\n  font-size: 13px !important;\n}\n\n@media (max-width: 900px) {\n  .challenge-top-row,\n  .challenge-bottom-row {\n    flex-direction: column;\n  }\n}\n\n@media (min-width: 901px) and (max-width: 1024px) {\n  .challenge-ocr-bar-label {\n    flex: 0 0 250px;\n    max-width: 130px;\n  }\n\n  .challenge-agents-chart-row {\n    gap: 10px !important;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1440px) {\n  .challenge-ocr-bar-label {\n    flex: 0 0 250px;\n    max-width: 160px;\n  }\n}\n\n@media (min-width: 1441px) {\n  .challenge-ocr-bar-label {\n    flex: 0 0 250px;\n    max-width: 250px;\n  }\n}\n\n.challenge-card-header .buttonContainer .MuiButton-text.MuiButton-textSuccess {\n  color: #3276cf;\n}\n.challenge-options .date-picker-container .colWiseControl {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.challenge-options .date-picker-container .controlLabel {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
